/* tslint:disable */
/* eslint-disable */
/**
 * CMA API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HoaFeeDto
 */
export interface HoaFeeDto {
    /**
     * 
     * @type {number}
     * @memberof HoaFeeDto
     */
    fee: number;
    /**
     * 
     * @type {string}
     * @memberof HoaFeeDto
     */
    frequency: string;
}

/**
 * Check if a given object implements the HoaFeeDto interface.
 */
export function instanceOfHoaFeeDto(value: object): value is HoaFeeDto {
    if (!('fee' in value) || value['fee'] === undefined) return false;
    if (!('frequency' in value) || value['frequency'] === undefined) return false;
    return true;
}

export function HoaFeeDtoFromJSON(json: any): HoaFeeDto {
    return HoaFeeDtoFromJSONTyped(json, false);
}

export function HoaFeeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): HoaFeeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'fee': json['fee'],
        'frequency': json['frequency'],
    };
}

export function HoaFeeDtoToJSON(json: any): HoaFeeDto {
    return HoaFeeDtoToJSONTyped(json, false);
}

export function HoaFeeDtoToJSONTyped(value?: HoaFeeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fee': value['fee'],
        'frequency': value['frequency'],
    };
}

